<template>
  <div class="storico-rottame" v-loading="loading">

    <!--
    <ricerca v-show="ricercaPanelVisible" @closeSearch="ricercaPanelVisible = false" @ricerca="ricerca" @loadingFalse="loading = false"></ricerca>
    -->
    <ricerca v-show="ricercaPanelVisible"
              @closeRicerca="closeSearch"
              @ricerca="ricerca"
              @stopLoading="(loading = false)"
              @changeCountry="changeCountry">
    </ricerca>

    <div class="header-tab row row-custom">
      <div class="col-4 no-padding icon-search">
        <el-button @click="openSearch">
          <el-tooltip class="item" effect="dark" :content="$t('elencoBuoni.ricerca')" placement="top-start">
            <icon name="riv-filter" scale="1.4"></icon>
          </el-tooltip>
        </el-button>
      </div>
      <div class="label-left col-16 no-padding">
        {{ $t('elencoBuoni.elencoBuoni').toUpperCase() }}
      </div>
      <div class="col-4 download-massivo">
        <el-tooltip class="item" effect="dark" :content="($t('elencoBuoni.downloadMassivo'))" placement="top">
          <el-button class="custom-button" @click="downloadMultiplo">
            <icon name="riv-downloadPas" scale="1.2"></icon>
          </el-button>
        </el-tooltip>
      </div>
    </div>

    <el-table :data="storicoBuoni" class="col-24 no-padding custom-table" ref="tabellaStorico">

      <el-table-column width="10" key="spazioSx"></el-table-column>

      <el-table-column v-if="!smallScreen" class-name="sfondino-conferme" key="nrConferma"
        prop="nrConferma" header-align="center" align="center"
        :label="$t('elencoBuoni.conferma')"
        width="85">
      </el-table-column>

      <el-table-column width="5" v-if="!smallScreen" key="spazioCentro"></el-table-column>

      <el-table-column v-if="!smallScreen" class-name="sfondino-buoni" key="nrBuono"
        prop="nrBuono" header-align="center" align="center"
        :label="$t('elencoBuoni.buono')"
        width="115">
      </el-table-column>

      <el-table-column width="5" v-if="!smallScreen" key="spazioDx"></el-table-column>

      <el-table-column
        :label="$t('elencoBuoni.veicolo')" key="veicolo"
        min-width="125">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ (scope.row.nrVagone === '') ? (scope.row.targaMot + ' - ' + scope.row.targaRim) : (scope.row.nrVagone) }}
          </div>
        </template>

      </el-table-column>

      <el-table-column align="center" v-if="!smallScreen" key="dataBuono" header-align="center"
                       :label="$t('elencoBuoni.dataBuono')"
                       min-width="105">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ moment(scope.row.dataBuono, 'YYYYMMDD').format('DD/MM/YYYY') }}
          </div>
        </template>

      </el-table-column>

      <el-table-column align="center" key="dataSped"
                       :label="$t('elencoBuoni.dataSped')"
                       min-width="105">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ moment(scope.row.dataSped, 'YYYYMMDD').format('DD/MM/YYYY') }}
          </div>
        </template>

      </el-table-column>

      <el-table-column align="center" v-if="!smallScreen" key="entrata"
        :label="$t('elencoBuoni.entrata')"
        min-width="120">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ moment(scope.row.dataEntrata, 'YYYYMMDD').format('DD/MM/YYYY') + ' - ' + moment(scope.row.oraEntrata, 'Hmm').format('HH:mm') }}
          </div>
        </template>

      </el-table-column>

      <el-table-column align="center" v-if="!smallScreen" key="uscita"
                       :label="$t('elencoBuoni.uscita')"
                       min-width="120">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ moment(scope.row.dataUscita, 'YYYYMMDD').format('DD/MM/YYYY') + ' - ' + moment(scope.row.oraUscita, 'Hmm').format('HH:mm') }}
          </div>
        </template>

      </el-table-column>

      <el-table-column align="center" key="dataBolla"
                       :label="$t('elencoBuoni.dataBolla')"
                       min-width="115">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ moment(scope.row.dataBolla, 'YYYYMMDD').format('DD/MM/YYYY') }}
          </div>
        </template>

      </el-table-column>

      <el-table-column header-align="center" align="center"
        :label="$t('elencoBuoni.bolla')" key="bolla"
        width="105">

        <template slot-scope="scope">
          <div class="pdf name-wrapper" v-if="scope.row.keyBolla">
            <span class="bolla">{{ scope.row.nrBolla }}</span>
            <el-tooltip class="item" popper-class="bolla-provvisoria" 
              effect="dark" :content="$t('elencoBuoni.bollaProvvisoria')" placement="top-start"
              v-if="(scope.row.seProvvisorio == 'P')"
            >
              <icon name="riv-pdfInfo" scale="1.5" class="pointer"  @click.native.stop="downloadBolla(scope.row)" />
            </el-tooltip>
            <el-tooltip class="item" effect="dark" 
              :content="$t('elencoBuoni.bollaEntrata')" placement="top-start"
              v-else
            >
              <icon name="riv-pdfNrm" scale="1.5" class="pointer"  @click.native.stop="downloadBolla(scope.row)" />
            </el-tooltip>
            <el-checkbox v-model="selectedBolle[scope.row.keyBolla]" :key="scope.row.keyBolla" @change="selectSingleBolla" class="custom-checkbox checkbox-ticket"></el-checkbox>
          </div>
        </template>

      </el-table-column>

      <!--
      <el-table-column
        width="45">

        <template slot="header">
          <el-checkbox v-model="allBolleSelected" @change="selectAllBolle"></el-checkbox>
        </template>
        <template slot-scope="scope">
          
        </template>

      </el-table-column>
      -->

      <el-table-column header-align="center" align="center"
        key="contestazioni" :label="$t('elencoBuoni.contestazioni')"
        width="105">

        <template slot-scope="scope">
          <div v-if="(scope.row.ifCont !== '0')" class="pdf name-wrapper">
            <el-tooltip class="item" effect="dark" :content="$t('elencoBuoni.letteraContestazione')" placement="top-start">
              <icon name="riv-pdfNrm" scale="1.5" class="pointer" @click.native.stop="downloadContestazione(scope.row)" />
            </el-tooltip>
            <el-checkbox class="custom-checkbox checkbox-ticket" v-if="(scope.row.keyContestazione !== '')" v-model="selectedContestazioni[scope.row.keyContestazione]" :key="scope.row.keyContestazione" @change="selectSingleContestazione"></el-checkbox>
          </div>
          <span v-else> - </span>
        </template>

      </el-table-column>

      <!--
      <el-table-column
        width="45">

        <template slot="header">
          <el-checkbox class="custom-checkbox" v-model="allContestazioniSelected" @change="selectAllContestazioni"></el-checkbox>
        </template>
        <template slot-scope="scope">
          
        </template>

      </el-table-column>
      -->

      <el-table-column header-align="center" align="center"
        key="ticketPesata" :label="$t('elencoBuoni.ticketPesata')"
        width="130">

        <template slot-scope="scope">
          <div class="pdf name-wrapper">
            <div v-if="scope.row.keySCP">
              <icon name="riv-pdfNrm" scale="1.5" class="pointer" @click.native.stop="downloadTicketPesata(scope.row)" />
              <el-checkbox class="custom-checkbox checkbox-ticket" v-model="selectedTicket[scope.row.keySCP]" :key="scope.row.keySCP"></el-checkbox>
            </div>
            <span v-else> - </span>
          </div>
        </template>

      </el-table-column>

      <el-table-column header-align="center" align="center"
        key="reso" :label="$t('elencoBuoni.reso')"
        v-if="form.country === '1'"
        width="105">

        <template slot-scope="scope">
          <div v-if="(scope.row.keyReso)" class="pdf name-wrapper">
            <icon name="riv-pdfNrm" scale="1.5" class="pointer" @click.native.stop="downloadReso(scope.row)" />
            <el-checkbox class="custom-checkbox checkbox-ticket" v-model="selectedReso[scope.row.keyReso]" :key="scope.row.keyReso"></el-checkbox>
          </div>
          <span v-else> - </span>
        </template>

      </el-table-column>

      <el-table-column header-align="center" align="center"
        key="foto"
        width="50">

        <template slot-scope="scope">
          <div class="pdf name-wrapper">
            <img src="../../../../static/img/download_image.png" class="download-img" @click="getFoto(scope.row)" />
          </div>
        </template>

      </el-table-column>

    </el-table>

    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage"
                   background class="custom-pagination"
                   layout="prev, pager, next"
                   :page-size="pag_for"
                   :page-count="nrPages"
                   @current-change="changePage">
    </el-pagination>

    <el-dialog :title="$t('elencoBuoni.buono').toUpperCase() + ' ' + (buonoSelected ? buonoSelected.nrBuono : '')"
               :visible.sync="fotoVisible" :append-to-body="true"
               custom-class="foto-dialog custom-dialog offset-xl-8 col-xl-8 offset-lg-7 col-lg-10 offset-md-6 col-md-12 offset-2 col-20">

      <el-table :data="foto" class="custom-table" v-loading="loadingFoto" :show-header="true">
        <el-table-column
          width="30"
          header-align="center"
          align="center"
          label="">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="allFotoSelected" @change="selectAllFoto" class="custom-checkbox checkbox-all"></el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox v-model="selectedFoto[scope.$index]" :key="scope.$index" @change="updateAllFotoSelectedFlag" class="custom-checkbox"></el-checkbox>
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('elencoBuoni.fotoPlurali')"
          min-width="150">
          <template slot-scope="scope">
            {{ $t('elencoBuoni.foto') + ' ' + (scope.$index + 1) }}
          </template>
        </el-table-column>

        <el-table-column
          width="40"
          align="center">
          <template slot-scope="scope">
            <div class="list-wrapper actions">
              <icon name="riv-downloadPas" scale="1.2" class="pointer" @click.native.stop="downloadFoto(scope.row, scope.$index)" />
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="foto-dialog-footer">
        <el-button @click="downloadMultiploFoto" type="primary" class="custom-button" :disabled="Object.values(selectedFoto).every(v => !v) || loadingFoto">
          {{ $t('elencoBuoni.downloadFoto').toUpperCase() }}
        </el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
  import {bus} from '../../Bus'
  import Ricerca from './Ricerca.vue'
  import moment from 'moment'

  export default {
    name: 'ElencoBuoni',
    components: {Ricerca},
    filters: {
      formatDate: function (date) {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      }
    },
    watch: {
      '$mq.resize': 'setSmallScreen'
    },
    i18n: {
      messages: {
        it_IT: {
          elencoBuoni: {
            conferma: 'Conferma',
            buono: 'Buono',
            veicolo: 'Veicolo',
            bolla: 'Bolla',
            contestazioni: 'Cont.ne',
            elencoBuoni: 'Elenco buoni',
            ricerca: 'Ricerca',
            bollaEntrata: 'Bolla di Entrata',
            letteraContestazione: 'Lettera Contestazione',
            bollaProvvisoria: 'La presente entrata è subordinata alla verifica della documentazione da parte dei nostri uffici competenti',
            dataBuono: 'Data Buono',
            dataSped: 'Spedizione',
            entrata: 'Entrata',
            uscita: 'Uscita',
            dataBolla: 'Data Bolla',
            downloadMassivo: 'Scarica tutti i documenti dei viaggi selezionati',
            downloadFoto: 'Download',
            ticketPesata: 'Ticket di Pesata',
            reso: 'Reso',
            foto: 'Foto',
            fotoPlurali: 'Foto'
          }
        },
        fr_FR: {
          elencoBuoni: {
            conferma: 'Commande',
            buono: 'Bon de décharg.',
            veicolo: 'Véhicule',
            bolla: 'Avis',
            contestazioni: 'Cont.',
            elencoBuoni: 'Liste bons décharg.',
            ricerca: 'Recherche',
            bollaEntrata: 'Avis d\'Entrée',
            letteraContestazione: 'Lettre de Contestation',
            bollaProvvisoria: 'Cette entrée est soumise à la vérification de la documentation par nos bureaux compétents',
            dataBuono: 'Date Bon',
            dataSped: 'Expédition',
            entrata: 'Entrée',
            uscita: 'Sortie',
            dataBolla: 'BDL',
            downloadMassivo: 'Déchargement de tous les documents de voyage sélectionnés',
            downloadFoto: 'Download',
            ticketPesata: 'Ticket de Pesée',
            reso: 'Retour',
            foto: 'Photo',
            fotoPlurali: 'Photos'
          }
        },
        es_ES: {
          elencoBuoni: {
            conferma: 'Contrato',
            buono: 'Vale descarga',
            veicolo: 'Vehículo',
            bolla: 'Albaran',
            contestazioni: 'Reclam.',
            elencoBuoni: 'Lista vales descarga',
            ricerca: 'Búsqueda',
            bollaEntrata: 'Albaran de entrada',
            letteraContestazione: 'Carta de Reclamacion',
            bollaProvvisoria: 'Este albaran está sujeto a la verificación de la documentación por parte de nuestras oficinas competentes',
            dataBuono: 'Fecha Cupón',
            dataSped: 'Envío',
            entrata: 'Entrada',
            uscita: 'Salida',
            dataBolla: 'Fecha Factura',
            downloadMassivo: 'Descarga de todos los documentos de viaje seleccionados',
            downloadFoto: 'Download',
            ticketPesata: 'Ticket Pesada',
            reso: 'Devolución',
            foto: 'Foto',
            fotoPlurali: 'Fotos'
          }
        },
        de_DE: {
          elencoBuoni: {
            conferma: 'Vertrag',
            buono: 'Entladescheine',
            veicolo: 'Fahrzeug',
            bolla: 'Eingang',
            contestazioni: 'Lieferbeanstandung',
            elencoBuoni: 'Übersicht Eingangsbelege',
            ricerca: 'Suche',
            bollaEntrata: 'Schrotteingang',
            letteraContestazione: 'Lieferbeanstandung Brief',
            bollaProvvisoria: 'Dieser Eingangsbeleg unterliegt noch der Überprüfung durch unser Büro',
            dataBuono: 'Datum Entladung',
            dataSped: 'Versanddatum',
            entrata: 'Eingang',
            uscita: 'Ausgang',
            dataBolla: 'Datum Rechnung',
            downloadMassivo: 'Ausgewählte Dokumente herunterladen',
            downloadFoto: 'Download',
            ticketPesata: 'Wiegekarte',
            reso: 'Rückgabe',
            foto: 'Foto',
            fotoPlurali: 'Fotos'
          }
        },
        en_GB: {
          elencoBuoni: {
            conferma: 'Conf.',
            buono: 'Voucher',
            veicolo: 'Vehicle',
            bolla: 'Bill',
            contestazioni: 'Cont.',
            elencoBuoni: 'Voucher List',
            ricerca: 'Search',
            bollaEntrata: 'Entry Bill',
            letteraContestazione: 'Letter Contestation',
            bollaProvvisoria: 'La presente entrata è subordinata alla verifica della documentazione da parte dei nostri uffici competenti',
            dataBuono: 'Voucher Date',
            dataSped: 'Shipment',
            entrata: 'Entry',
            uscita: 'Exit',
            dataBolla: 'Bill\'s Date',
            downloadMassivo: 'Download of all selected travel documents',
            downloadFoto: 'Download',
            ticketPesata: 'Weighing Ticket',
            reso: 'Return',
            foto: 'Photo',
            fotoPlurali: 'Photos'
          }
        }
      }
    },
    data () {
      return {
        codLang: sessionStorage.getItem('codLang'),
        storicoBuoni: [],
        form: {},
        pag_for: 12,
        smallScreen: false,
        nrPages: 0,
        currentPage: 1,
        ricercaPanelVisible: false,
        loading: true,
        moment: moment,
        selectedBolle: {},
        selectedContestazioni: {},
        allBolleSelected: false,
        allContestazioniSelected: false,
        codForn: '',
        selectedTicket: {},
        selectedReso: {},
        foto: [],
        loadingFoto: false,
        fotoVisible: false,
        buonoSelected: null,
        selectedFoto: {},
        allFotoSelected: false
      }
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
      })
      bus.$on('Header_SetCodFornAdmin', () => {
        this.$set(this, 'storicoBuoni', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'currentPage', 1)
      })
      bus.$on('TRAACQ_ChangeCountryFromDsh', () => {
        this.$set(this, 'storicoBuoni', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'currentPage', 1)
      })
    },
    methods: {
      downloadFoto: function (foto, index) {
        this.$set(this, 'loadingFoto', true)
        const minLoaderMs = 700
        const startTs = Date.now()
        const stopLoading = () => {
          const elapsed = Date.now() - startTs
          const waitMs = Math.max(minLoaderMs - elapsed, 0)
          setTimeout(() => {
            this.$set(this, 'loadingFoto', false)
          }, waitMs)
        }
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let fileName = this.buonoSelected.nrBuono + '_' + (index + 1) + '.jpg'
              let url = (process.env.baseUrlSpringRottame + 'download/foto' +
                '?keyDoc=' + encodeURIComponent(foto.chiave) +
                '&nomeFile=' + encodeURIComponent(this.buonoSelected.nrBuono + '_' + (index + 1)) +
                '&token=' + response.body.wsToken
              )
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', fileName)
              link.setAttribute('target', '_self')
              document.body.appendChild(link)
              link.click()
              link.remove()
              stopLoading()
            } else {
              stopLoading()
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
          .catch(() => {
            stopLoading()
            this.$message({
              showClose: true,
              message: 'Error creating token',
              type: 'error',
              duration: process.env.duration
            })
          })
      },
      getFoto: function(buono) {
        this.$set(this, 'loadingFoto', true)
        this.$set(this, 'foto', [])
        this.$set(this, 'fotoVisible', true)
        this.$set(this, 'buonoSelected', buono)
        this.$set(this, 'selectedFoto', {})
        this.$set(this, 'allFotoSelected', false)
        this.$http.get('storicorottame/foto', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1),
            codStab: this.form.codStab,
            nrConferma: buono.nrConferma,
            nrBuono: buono.nrBuono,
            targaMot: buono.targaMot,
            targaRim: buono.targaRim
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'foto', response.body.data)
              this.foto.forEach((item, index) => {
                this.$set(this.selectedFoto, index, false)
              })
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'fotoVisible', false)
              this.$set(this, 'buonoSelected', null)
            }
            this.$set(this, 'loadingFoto', false)
          })
          .catch((err) => {
            this.$set(this, 'loadingFoto', false)
            this.$set(this, 'fotoVisible', false)
            this.$set(this, 'buonoSelected', null)
            this.$message({
              showClose: true,
              message: err.body && err.body.msg ? err.body.msg[0].msgTxt : 'Error getting photos',
              type: 'error',
              duration: process.env.duration
            })
          })
      },
      updateAllFotoSelectedFlag: function () {
        const allSelected = this.foto.length > 0 && this.foto.every((item, index) => this.selectedFoto[index])
        this.$set(this, 'allFotoSelected', allSelected)
      },
      selectAllFoto: function (flag) {
        this.foto.forEach((item, index) => {
          this.$set(this.selectedFoto, index, flag)
        })
      },
      downloadMultiploFoto: function () {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              const token = response.body.wsToken
              const minLoaderMs = 500
              const startTs = Date.now()
              this.$set(this, 'loadingFoto', true)

              let downloadCount = 0
              const totalToDownload = Object.values(this.selectedFoto).filter(v => v).length

              this.foto.forEach((item, index) => {
                if (this.selectedFoto[index]) {
                  // Delay incrementale per evitare conflitti di download al browser
                  setTimeout(() => {
                    let fileName = this.buonoSelected.nrBuono + '_' + (index + 1) + '.jpg'
                    let url = (process.env.baseUrlSpringRottame + 'download/foto' +
                      '?keyDoc=' + encodeURIComponent(item.chiave) +
                      '&nomeFile=' + encodeURIComponent(this.buonoSelected.nrBuono + '_' + (index + 1)) +
                      '&token=' + token
                    )

                    // Usa $http con arraybuffer come downloadMultiplo per evitare conflitti
                    this.$http({
                      method: 'get',
                      url: url,
                      responseType: 'arraybuffer'
                    }).then(response => {
                      let imageData = new Blob([response.data])
                      if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                        window.navigator.msSaveOrOpenBlob(imageData, fileName)
                      } else { // for Non-IE (chrome, firefox etc.)
                        const imageUrl = window.URL.createObjectURL(imageData)
                        const link = document.createElement('a')
                        link.href = imageUrl
                        link.setAttribute('download', fileName)
                        document.body.appendChild(link)
                        link.click()
                        URL.revokeObjectURL(imageUrl)
                        link.remove()
                      }

                      downloadCount++

                      // Spegni il loader solo quando tutti i download sono completati
                      if (downloadCount === totalToDownload) {
                        const elapsed = Date.now() - startTs
                        const waitMs = Math.max(minLoaderMs - elapsed, 0)
                        setTimeout(() => {
                          this.$set(this, 'loadingFoto', false)
                        }, waitMs)
                      }
                    })
                  }, index * 800) // Delay di 800ms per foto per evitare conflitti browser
                }
              })
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
          .catch(() => {
            this.$message({
              showClose: true,
              message: 'Error creating token',
              type: 'error',
              duration: process.env.duration
            })
          })
      },
      downloadReso: function (bollaReso) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringRottame + 'download/bollareso' +
                '?keyDoc=' + bollaReso.keyReso +
                '&nomeFile=' + encodeURIComponent(this.$t('elencoBuoni.reso') + '_' + bollaReso.nrBuono) +
                '&token=' + response.body.wsToken
              )
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      downloadTicketPesata: function (ticket) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringRottame + 'download/ticketpesata' +
                '?keyDoc=' + ticket.keySCP +
                '&nomeFile=' + encodeURIComponent(this.$t('elencoBuoni.ticketPesata') + '_' + ticket.nrBuono) +
                '&token=' + response.body.wsToken
              )
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      downloadBolla: function (bolla) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringRottame + 'download/bollaentrata' +
                '?keyDoc=' + bolla.keyBolla +
                '&nomeFile=' + encodeURIComponent(this.$t('elencoBuoni.bollaEntrata') + '_' + bolla.nrBuono) +
                '&token=' + response.body.wsToken
              )
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      downloadContestazione: function (contestazione) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringRottame + 'download/contestazione' +
                '?keyDoc=' + contestazione.keyContestazione +
                '&nomeFile=' + encodeURIComponent(this.$t('elencoBuoni.letteraContestazione') + '_' + contestazione.nrBuono) +
                '&token=' + response.body.wsToken
              )
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      selectSingleBolla: function (flag) {
        if (flag === false) {
          this.$set(this, 'allBolleSelected', false)
        } else {
          const keys = Object.keys(this.selectedBolle)
          let boolean = true
          for (const key of keys) {
            if (this.selectedBolle[key] === false) {
              boolean = false
            }
          }
          this.$set(this, 'allBolleSelected', boolean)
        }
      },
      selectSingleContestazione: function (flag) {
        if (flag === false) {
          this.$set(this, 'allContestazioniSelected', false)
        } else {
          const keys = Object.keys(this.selectedContestazioni)
          let boolean = true
          for (const key of keys) {
            if (this.selectedContestazioni[key] === false) {
              boolean = false
            }
          }
          this.$set(this, 'allContestazioniSelected', boolean)
        }
      },
      selectAllBolle: function (flag) {
        this.storicoBuoni.forEach(item => {
          this.$set(this.selectedBolle, item.keyBolla, flag)
        })
      },
      selectAllContestazioni: function (flag) {
        this.storicoBuoni.forEach(item => {
          this.$set(this.selectedContestazioni, item.keyContestazione, flag)
        })
      },
      downloadMultiplo: function () {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let token = response.body.wsToken
              this.storicoBuoni.forEach(item => {
                if (this.selectedBolle[item.keyBolla] && item.keyBolla) {
                  let urlBolla = (process.env.baseUrlSpringRottame + 'download/bollaentrata' +
                    '?keyDoc=' + item.keyBolla +
                    '&token=' + token
                  )
                  this.$http({
                    method: 'get',
                    url: urlBolla,
                    responseType: 'arraybuffer'
                  })
                    .then(response => {
                      let csvData = new Blob([response.data])
                      if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                        window.navigator.msSaveOrOpenBlob(csvData, this.$t('elencoBuoni.bollaEntrata') + '_' + item.nrBuono + '.pdf')
                      } else { // for Non-IE (chrome, firefox etc.)
                        const url = window.URL.createObjectURL(csvData)
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', this.$t('elencoBuoni.bollaEntrata') + '_' + item.nrBuono + '.pdf')
                        document.body.appendChild(link)
                        link.click()
                        URL.revokeObjectURL(link.href)
                        link.remove()
                      }
                    })
                }
                if (this.selectedContestazioni[item.keyContestazione] && item.keyContestazione) {
                  let urlCont = (process.env.baseUrlSpringRottame + 'download/contestazione' +
                    '?keyDoc=' + item.keyContestazione +
                    '&token=' + token
                  )
                  this.$http({
                    method: 'get',
                    url: urlCont,
                    responseType: 'arraybuffer'
                  })
                    .then(response => {
                      let csvData = new Blob([response.data])
                      if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                        window.navigator.msSaveOrOpenBlob(csvData, this.$t('elencoBuoni.letteraContestazione') + '_' + item.nrBuono + '.pdf')
                      } else { // for Non-IE (chrome, firefox etc.)
                        const url = window.URL.createObjectURL(csvData)
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', this.$t('elencoBuoni.letteraContestazione') + '_' + item.nrBuono + '.pdf')
                        document.body.appendChild(link)
                        link.click()
                        URL.revokeObjectURL(link.href)
                        link.remove()
                      }
                    })
                }
                if (this.selectedTicket[item.keySCP] && item.keySCP) {
                  let urlCont = (process.env.baseUrlSpringRottame + 'download/ticketpesata' +
                    '?keyDoc=' + item.keySCP +
                    '&token=' + token
                  )
                  this.$http({
                    method: 'get',
                    url: urlCont,
                    responseType: 'arraybuffer'
                  })
                    .then(response => {
                      let csvData = new Blob([response.data])
                      if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                        window.navigator.msSaveOrOpenBlob(csvData, this.$t('elencoBuoni.ticketPesata') + '_' + item.nrBuono + '.pdf')
                      } else { // for Non-IE (chrome, firefox etc.)
                        const url = window.URL.createObjectURL(csvData)
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', this.$t('elencoBuoni.ticketPesata') + '_' + item.nrBuono + '.pdf')
                        document.body.appendChild(link)
                        link.click()
                        URL.revokeObjectURL(link.href)
                        link.remove()
                      }
                    })
                }
                if (this.selectedReso[item.keyReso] && item.keyReso) {
                  let urlReso = (process.env.baseUrlSpringRottame + 'download/bollareso' +
                    '?keyDoc=' + item.keyReso +
                    '&token=' + token
                  )
                  this.$http({
                    method: 'get',
                    url: urlReso,
                    responseType: 'arraybuffer'
                  })
                    .then(response => {
                      let csvData = new Blob([response.data])
                      if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                        window.navigator.msSaveOrOpenBlob(csvData, this.$t('elencoBuoni.reso') + '_' + item.nrBuono + '.pdf')
                      } else { // for Non-IE (chrome, firefox etc.)
                        const url = window.URL.createObjectURL(csvData)
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', this.$t('elencoBuoni.reso') + '_' + item.nrBuono + '.pdf')
                        document.body.appendChild(link)
                        link.click()
                        URL.revokeObjectURL(link.href)
                        link.remove()
                      }
                    })
                }
              })
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      init: function () {
        if (sessionStorage.hasOwnProperty('WSR_form')) {
          this.$set(this, 'form', JSON.parse(sessionStorage.getItem('WSR_form')))
          this.$set(this, 'codForn', this.form.fornitore.tipForn + this.form.fornitore.codForn)
          this.ricerca()
        }
      },
      resetDati: function () {
        this.$set(this, 'storicoBuoni', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'currentPage', 1)
        this.$set(this, 'ricercaPanelVisible', false)
        this.$set(this, 'selectedBolle', {})
        this.$set(this, 'selectedContestazioni', {})
        this.$set(this, 'allBolleSelected', false)
        this.$set(this, 'allContestazioniSelected', false)
        this.$set(this, 'selectedTicket', {})
      },
      changeCountry: function () {
        this.$set(this, 'storicoBuoni', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'currentPage', 1)
        this.$set(this, 'selectedBolle', {})
        this.$set(this, 'selectedContestazioni', {})
        this.$set(this, 'allBolleSelected', false)
        this.$set(this, 'allContestazioniSelected', false)
        this.$set(this, 'selectedTicket', {})
      },
      ricerca: function () {
        this.$set(this, 'loading', true)
        this.form = JSON.parse(sessionStorage.getItem('WSR_form'))
        this.$set(this, 'codForn', this.form.fornitore.tipForn + this.form.fornitore.codForn)
        this.ricercaPanelVisible = false
        if (this.form.numBuono !== '' || this.form.numConf !== '') {
          this.$set(this, 'currentPage', 1)
        }
        this.getStoricoViaggi()
      },
      setSmallScreen: function () {
        if (document.documentElement.clientWidth <= 1450) {
          this.smallScreen = true
        } else {
          this.smallScreen = false
        }
      },
      openSearch: function () {
        this.ricercaPanelVisible = true
        this.$emit('hideScroll')
      },
      closeSearch: function () {
        this.ricercaPanelVisible = false
        this.$emit('showScroll')
      },
      changePage: function (page) {
        this.$set(this, 'loading', true)
        this.$set(this, 'currentPage', page)
        this.getStoricoViaggi()
      },
      getStoricoViaggi: function () {
        bus.$emit('Header_ChangeAdmin', this.form.country, 'TRAACQ')
        if (localStorage.getItem('TRAACQ_country') !== this.form.country) {
          localStorage.setItem('TRAACQ_country', parseInt(this.form.country))
          bus.$emit('TRAACQ_ChangeCountryFromApp')
        }
        this.$http.get('storicorottame/viaggi', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1),
            codStab: this.form.codStab,
            dataEntrataDa: this.form.dataBolla[0],
            dataEntrataA: this.form.dataBolla[1],
            dataSpedDa: this.form.dataSped[0],
            dataSpedA: this.form.dataSped[1],
            pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
            pag_from: this.currentPage - 1,
            pag_for: this.pag_for,
            orderBy: '1A',
            nrBuono: this.form.numBuono.toUpperCase(),
            nrConferma: this.form.numConf.toUpperCase()
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.storicoBuoni = response.body.data
              this.$set(this, 'selectedBolle', {})
              this.$set(this, 'allBolleSelected', false)
              this.$set(this, 'allContestazioniSelected', false)
              this.storicoBuoni.forEach((item, index) => {
                this.$set(this.selectedBolle, item.keyBolla, false)
                this.$set(this.selectedContestazioni, item.keyContestazione, false)
              })
              this.nrPages = parseInt(parseInt(response.body.attrib.size) / this.pag_for)
              if (parseInt(response.body.attrib.size) % this.pag_for > 0) {
                this.nrPages++
              }
            } else {
              if (response.body.msg[0].msgId !== '1001') {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
              this.$set(this, 'storicoBuoni', [])
              this.$set(this, 'nrPages', 0)
              this.$set(this, 'currentPage', 1)
            }
            this.$set(this, 'loading', false)
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .foto-dialog {
    .el-dialog__header {
      border-bottom: none;
    }
    .el-table {
      .custom-checkbox {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0;
      }
    }
    .foto-dialog-footer {
      margin-top: 20px;
      text-align: right;
    }
  }

  .storico-rottame {
    .header-tab {
      height: 65px;
      text-align: center;
      .download-massivo {
        .el-button {
          float: right;
          margin-top: 30px;
          border: 1px solid @oroRiva;
          padding: 6px 10px;
        }
      }
      .label-left {
        line-height: 55px;
        height: 45px;
        .set-font(@color: @oroRiva; @size: 22px; @family: 'os-semibolditalic');
        letter-spacing: 2px;
      }
      .icon-search {
        line-height: 65px;
        .el-button {
          height: 40px;
          width: 40px;
          border-radius: 0;
          margin: 12px 0 0 10px;
          padding: 0;
          color: @greenRiva;
          float: left;
          border: 1px solid @greenRiva;
        }
        .el-button:hover {
          background-color: @white;
        }
      }
    }
    .el-table {
      height: 470px;
      margin-top: 10px;
      .el-table__body-wrapper {
        tbody {
          tr {
            td {
              &.sfondino-buoni {
                background-color: #f0f3fa;
              }
              &.sfondino-conferme {
                background-color: #edf6f5;
              }
            }
            .cell {
              .download-img {
                width: 20px;
                height: 23px;
                cursor: pointer;
              }
              .pdf {
                line-height: 23px;
                display: flex;
                justify-content: center;
                a {
                  color: @greenRiva;
                  .fa-icon {
                    outline-color: @white;
                  }
                }
                a:hover {
                  color: @greenRiva;
                }
                a:visited {
                  color: @greenRiva;
                }
                .link {
                  display: inline-block;
                  padding-left: 5px;
                }
                .bolla {
                  display: inline-block;
                  margin-right: 5px;
                }
                .checkbox-ticket {
                  width: 20px;
                  .is-focus {
                    .el-checkbox__inner {
                      border-color: @greenRiva;
                    }
                  }
                }
              }
              label {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }

  .el-tooltip__popper {
    &.bolla-provvisoria {
      background: #d5ebf6 !important;
      color: #426583;
      .popper__arrow::after {
        border-top-color: #d5ebf6;
      }
      .popper__arrow {
        border-color: transparent;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebStoricoRottame/ElencoBuoni.vue